import discardForwardingOption from './actions/discardForwardingOption';
import saveForwardingOption from './actions/saveForwardingOption';
import ForwardingFull from './components/ForwardingFull';
import isForwardingFormInvalid from './utils/isForwardingFormInvalid';
import isForwardingOptionDirty from './utils/isForwardingOptionDirty';
import { Option } from 'owa-options-core';
import * as React from 'react';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';

const ForwardingOption: Option = {
    key: 'forwardingOption',
    titleStringKey: 'optionTitle_forwarding',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_forwarding',
    fullOptionFormSettings: {
        render: () => <ForwardingFull />,
        isDirty: isForwardingOptionDirty,
        onSave: saveForwardingOption,
        onDiscard: discardForwardingOption,
        disableSave: isForwardingFormInvalid,
    },
    isHidden: () => IsShadowMailboxUser(),
    allowedOptionKeys: ['Forwarding'],
};

export default ForwardingOption;
